import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CredentialsSetup from './CredentialsSetup';
import CleanTradingDashboard from './CleanTradingDashboard';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import './App.css';
const CleanApp = () => {
  const [walletConnected, setWalletConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');
  const [credentialsSet, setCredentialsSet] = useState(false);
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const connectWallet = async () => {
    if ((window as any).ethereum) {
      try {
        const accounts = await (window as any).ethereum.request({
          method: "eth_requestAccounts"
        });
        setWalletAddress(accounts[0]);
        setWalletConnected(true);
        alert("Auto-load check starting...");
        const autoLoadResponse = await fetch(`/api/credentials/auto-load/${accounts[0]}`);
        const autoLoadData = await autoLoadResponse.json();
        if (autoLoadData.success && autoLoadData.loaded) {
          const useStored = window.confirm("Stored credentials found! Choose:\n\nOK = Use Stored Credentials\nCancel = Enter New Credentials");
          if (useStored) {
            setCredentialsSet(true);
          }
        }
      } catch (error) {
        alert("Connection failed");
      }
    } else {
      alert("Please install MetaMask!");
    }
  };
  const handleCredentialsComplete = () => {
    setCredentialsSet(true);
  };

  return (
    <Router>
      <Routes>
        <Route path="/backoffice" element={
          adminLoggedIn ? 
            <AdminDashboard /> : 
            <AdminLogin onLogin={() => setAdminLoggedIn(true)} />
        } />
        <Route path="/" element={
          <div className="app">
            <header className="app-header">
              <h1>SmartTrade 24/7</h1>
              {walletConnected && (
                <span className="wallet-info">
                  {walletAddress.slice(0, 6)}...{walletAddress.slice(-4)}
                </span>
              )}
            </header>
            <main className="app-main">
              {!walletConnected ? (
                <div className="connect-container">
                  <h2>Connect Your Wallet</h2>
                  <button className="btn" onClick={connectWallet}>
                    Connect MetaMask
                  </button>
                </div>
              ) : !credentialsSet ? (
                <CredentialsSetup 
                  walletAddress={walletAddress}
                  onCredentialsComplete={handleCredentialsComplete}
                />
              ) : (
                <CleanTradingDashboard walletAddress={walletAddress} />
              )}
            </main>
          </div>
        } />
      </Routes>
    </Router>
  );
};

export default CleanApp;
